// extracted by mini-css-extract-plugin
module.exports = {"wysiwyg__error":"SGSWysiwyg_wysiwyg__error__1XYnr","label":"SGSWysiwyg_label__3AStW","label__error":"SGSWysiwyg_label__error__B82Gc"};